module.exports = __webpack_public_path__ + "img/mind_skeleton_flowchart_1.07d3cab1.png";